import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DialogRef } from '@components/dialog/dialog-ref';
import { DeliveryOrder } from '@core/models/delivery/delivery-order';
import { ToastService } from '@core/state/toast/toast.service';
import { DeliveriesService } from '../deliveries.service';
import { UpdateDeliveryOrderRequest } from '@core/models/delivery/update-delivery-order.request';
import { ApiErrorResponse } from '@core/data/api/error-response';

@Component({
    selector: 'ihd-dialog-manager-note',
    templateUrl: 'dialog-manager-note.component.html',
    styleUrls: ['./dialog-manager-note.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-dialog-manager-note',
    },
})
export class DialogManagerNoteComponent implements OnInit {
    public config;
    public order: DeliveryOrder;
    public editForm: FormGroup;
    public busy: boolean = false;

    constructor(
        public dialogRef: DialogRef<DialogManagerNoteComponent>,
        private toastService: ToastService,
        private ordersService: DeliveriesService,
        private cdr: ChangeDetectorRef
    ) {
        if (dialogRef.containerInstance && dialogRef.containerInstance.config) {
            this.config = dialogRef.containerInstance.config;
            this.order = this.config.order;
            this.createForm();

            if (this.order && this.order.managerNote?.note) {
                this.editForm.patchValue({
                    managerNote: this.order.managerNote.note,
                });
            }
        }
    }

    ngOnInit() {}

    sendRequest() {
        if (this.editForm.valid) {
            this.busy = true;
            this.cdr.markForCheck();

            const { managerNote } = this.editForm.value;
            const request = new UpdateDeliveryOrderRequest();
            request.managerNote = managerNote;

            this.ordersService.updateDeliveryOrder(this.order.id, request).subscribe(
                (res: any) => {
                    this.toastService.showSuccess('Order.Note.Update.Success');
                    this.close();
                },
                (error: { payload: ApiErrorResponse }) => {
                    this.toastService.showApiError(error);
                    this.busy = false;
                    this.cdr.markForCheck();
                }
            );
        } else {
            this.toastService.showWarning('Errors.FormInvalid');
        }
    }

    close() {
        this.dialogRef.close();
    }

    private createForm() {
        this.editForm = new FormGroup({
            managerNote: new FormControl(null),
        });
    }
}
